// extracted by mini-css-extract-plugin
export var active = "_bt-7";
export var container = "_bt-0";
export var evenWidth = "_bt-4";
export var large = "_bt-5";
export var outlet = "_bt-8";
export var slide = "_bt-2";
export var small = "_bt-6";
export var tab = "_bt-3";
export var tabs = "_bt-1";